export interface MenuItemProps {
  title: string;
  icon?: React.ReactElement;
  subMenu?: MenuItemProps[];
  to?: string;
  key: string;
  permissions?: string[] | '*';
}
export interface MenuGroupProps {
  groupName: string;
  items: MenuItemProps[];
}
// Global
export const BaseGlobalConfigurationsUrl = `/cms/configurations`;
export const BaseGlobalOperationsUrl = `/cms/operations`;
export const BaseGlobalPassengerAppUrl = `/cms/passenger-app`;
export const BaseGlobalMonitoringUrl = `/cms/monitoring`;

// Company
export const BaseCompanySellingUrl = `/cms/selling`;
export const BaseCompanyManagementUrl = `/cms/management`;
export const BaseCompanyGrowingUrl = `/cms/growing`;
